import { useTranslation, Trans } from 'react-i18next';
import Typography from '../../sharedComponents/Typography/Typography';
import styles from './paypal-maintenance-notice.module.scss';

const PayPalMaintenanceNotice: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Typography
        variant="body-2"
        className={styles.maintenanceText}
        color="status red"
      >
        {t('sunshine.paypal_maintenance_notice.explainer')}
      </Typography>

      <Typography variant="label-3" className={styles.maintenanceText}>
        <Trans i18nKey="sunshine.paypal_maintenance_notice.customer_support">
          <a href={`mailto:${t('generic.label.customer_support_email')}`}>
            {t('generic.label.customer_support_email')}
          </a>
        </Trans>
      </Typography>
    </>
  );
};

export default PayPalMaintenanceNotice;
